/* eslint-disable @typescript-eslint/no-unnecessary-condition */
// Build fails without this rule disable. `origin` is undefined in SSR
import { useLocation } from '@gatsbyjs/reach-router';

import {
  isProduction as _isProduction,
  isStaging as _isStaging,
  isDevelopment,
} from '@constants/env';

export function useEnv() {
  const location = useLocation();
  const origin = location.origin;
  const isProduction = _isProduction || origin?.includes('app.vitall.com');
  const isStaging = _isStaging || origin?.includes('app-staging.vitall.com');
  const isLocal = isDevelopment || origin?.includes('localhost');
  return { isProduction, isStaging, isLocal };
}
